import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    titles: [],
  }),

  mutations: {
    setTitles(state, titles) {
      Vue.set(state, "titles", titles);
    },
  },

  actions: {
    //TODO: load, update, create
    createTitle: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/titles/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadTitles: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadTitle: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadPublishedTitles: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/entity/published").then((response) => {
        // context.commit("setTitles",response.data);
        return response;
      });
    },

    loadTitleHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/titles/entity/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedTitleHistory: (context, title) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/history/" + title.id, {}).then((response) => {
        return response.data;
      });
    },

    searchTitleByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/titles/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteTitle: (context, title) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/titles/entity/" + title.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          title.intents = intents;
          title.intentId = response.data.id;
          return title;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftTitle: (context, title) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/titles/draft/" + title.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishTitle: (context, title) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/publish/" + title.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectTitle: (context, title) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/reject/" + title.intentId).then((response) => {
        helper.recallOrRejectEntity(title, "title");
        return response.data;
      });
    },

    sendToApprovalTitles: (context, title) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/sendToApproval/" + title.intentId).then((response) => {
        if (title.intents[0].type === "CREATE_TITLE") {
          title.intents[0].status = "WAITING_APPROVAL";
        } else if (title.intents[0].type === "UPDATE_TITLE") {
          title.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallTitle: (context, title) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/recall/" + title.intentId).then((response) => {
        helper.recallOrRejectEntity(title, "title");
        return response.data;
      });
    },

    cancelTitle: (context, title) => {
      return axios.get(context.getters.getMcServiceUrl + "/titles/cancel/" + title.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getTitles: (state) => {
      return state.titles;
    },
    getPublishedTitles: (state) => {
      return state.titles.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
